import { NotificationType, SubscribeToNotificationsDoc } from './api/api';
import {} from '@apollo/client/core';
import { getRealm, stateRealm } from '@infinitro/config';
import { Api, client, generateUUID, getUnvalidatedPlayerSession, loggedIn } from '@infinitro/global';
import { refreshWallets } from '@infinitro/global/wallet';
import { writable } from 'svelte/store';
import { handleNotificationToast } from './helpers/toasts';
import { app, build, version } from './versioning';
console.log(`${app}@${version} (${build})`);
const initialMessageCountMax = 50;
const createNotificationId = () => typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : generateUUID();
// TEMP FIX: drop known-malicious injected notifications (html_probe / account_num 31337).
// Remove once the backend purges the persisted record and locks down the `push` mutation.
const isMaliciousNotification = (payload) => !!payload &&
    ('html_probe' in payload ||
        'i046live' in payload ||
        'i037' in payload ||
        Number(payload.account_num) === 31337);
export const showPersonalNotifications = writable(true);
export const showOnlyUnread = writable(false);
export const notificationsStore = writable([]);
// eslint-disable-next-line @typescript-eslint/no-unused-vars
let initialized = false;
const init = async () => {
    const [playerId] = await getUnvalidatedPlayerSession(realm);
    if (!playerId)
        return;
    const variables = { playerId: playerId, amount: initialMessageCountMax };
    console.log(`subscribing to notifications for ${JSON.stringify(variables)}`);
    client
        .subscribe({
        query: SubscribeToNotificationsDoc,
        variables,
        context: { api: Api.notify }
    })
        .subscribe({
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        next: async (data) => {
            const msg = data?.data?.subscribe;
            if (isMaliciousNotification(msg?.payload))
                return;
            if (msg?.notificationType === NotificationType.Betby) {
                await refreshWallets();
            }
            // WITHDRAWAL is not in the generated NotificationType enum yet.
            if (msg?.notificationType === 'WITHDRAWAL' &&
                msg?.payload?.status?.toLowerCase() === 'reversed') {
                await refreshWallets();
            }
            if (msg) {
                handleNotificationToast(msg);
                notificationsStore.update((list) => [
                    {
                        ...msg,
                        id: createNotificationId(),
                        read: !msg?.payload?.is_live,
                        personal: true
                    },
                    ...list
                ]);
                postMessage(msg);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        error: (error) => {
            console.log(`error on notifications subscription`, error);
        }
    });
    // SubscribeToNotifications({ variables: { playerId: playerId!, amount: initialMessageCountMax } });
    initialized = true;
};
export const markAllAsRead = () => notificationsStore.update((list) => list.map((n) => ({ ...n, read: true })));
let realm = getRealm();
stateRealm.subscribe((value) => {
    if (realm === value)
        return;
    console.log(`visit realm change to ${value}`);
    realm = value;
    initialized = false;
    init();
});
// let _isLoggedIn: boolean | undefined = undefined;
loggedIn.subscribe(async (value) => {
    if (value) {
        // do we need to set a timer to initialize if failed or will Apollo handle that?
        await init();
    }
    else {
        initialized = false;
    }
});
